/* Two versions side by side in the editor's preview column (owner report, round 3). */
.compare {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-block-size: 0;
  background: var(--canvas);
}

.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  border-bottom: 1px solid var(--border);
  background: var(--surface-raised);
}

.title {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.title:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.spacer {
  flex: 1;
}

.panes {
  display: grid;
  flex: 1;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-3);
  min-block-size: 0;
  padding: var(--space-3);
}

.pane {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 0;
  min-block-size: 0;
  margin: 0;
}

.label {
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
}

/* The frame keeps its layout width; the scale makes it fit the half it has. */
.stage {
  --compare-width: 1280px;
  --compare-scale: 1;

  position: relative;
  flex: 1;
  min-block-size: 320px;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--surface-raised);
}

.frame {
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  inline-size: var(--compare-width);
  block-size: calc(100% / var(--compare-scale));
  border: 0;
  transform: scale(var(--compare-scale));
  transform-origin: top left;
}

.code {
  flex: 1;
  overflow: auto;
  padding: var(--space-4);
}

.codeHeading {
  margin: 0 0 var(--space-3);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

@media (max-width: 1023.98px) {
  .panes {
    grid-template-columns: 1fr;
  }
}
